import { AuthLayout } from '@/components/auth/auth-layout';
import { SignUpForm } from '@/components/auth/sign-up-form';
import { ensureAuthConfig } from '@/lib/auth-config';
import { ensureSession } from '@/lib/session';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/signup')({
  beforeLoad: async ({ context }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status === 'authenticated') {
      throw redirect({ to: '/chat' });
    }
    // No local registration under SSO — Authentik owns identity. Bounce to the
    // sign-in page, which shows the single "Continue with Authentik" button.
    const authConfig = await ensureAuthConfig(context.queryClient);
    if (authConfig.ssoEnabled) {
      throw redirect({ to: '/signin' });
    }
  },
  component: SignUpRoute,
});

function SignUpRoute() {
  return (
    <AuthLayout testId="signup-route">
      <SignUpForm />
    </AuthLayout>
  );
}
